export const iconFontAwesomeHumanitarianPersonMilitaryRifle = (
	<i className="fa-solid fa-person-military-rifle"></i>
);
